import React, { useEffect, useRef, useState } from "react";
// import Table from "@components/Table";
import { Switch } from "antd";
import { useParams } from "react-router-dom";
import "./style.less";
import {
  useFetchAllBusinessUnitsQuery,
  useFetchJobGradesByCountryQuery,
  // useFetchAllJobFunctionsQuery,
  useFetchAllCompanyFunctionsQuery,
} from "@services";
import { useTypedSelector } from "@hooks";
import PermissionsTable from "../PermissionTable";
import {
  IBusinessUnitItem,
  ICountry,
  IJobFunctionItem,
  IJobGrade,
  IRegion,
} from "@types";
import Select from "react-select";
type RolePermissions = {
  [role: string]: string[];
};

const rolePermissions: RolePermissions = {
  TOM_MASTER_USER: [
    "CREATE_BUSINESS_UNIT",
    "VIEW_BUSINESS_UNIT",
    "UPDATE_BUSINESS_UNIT",
    "DELETE_BUSINESS_UNIT",
    "CREATE_REGION",
    "VIEW_REGION",
    "UPDATE_REGION",
    "DELETE_REGION",
    "VIEW_COUNTRY",
    "CREATE_COUNTRY",
    "UPDATE_COUNTRY",
    "DELETE_COUNTRY",
  ],

  TOM_SUPER_USER: [
    "CREATE_BUSINESS_UNIT",
    "VIEW_BUSINESS_UNIT",
    "VIEW_REGION",
    "CREATE_REGION",
    "VIEW_COUNTRY",
    "CREATE_COUNTRY",
  ],

  TOM_ADMIN: [
    "CREATE_BUSINESS_UNIT",
    "VIEW_BUSINESS_UNIT",
    "VIEW_REGION",
    "CREATE_REGION",
    "VIEW_COUNTRY",
    "CREATE_COUNTRY",
  ],

  TOM_SALES: [
    "CREATE_BUSINESS_UNIT",
    "VIEW_BUSINESS_UNIT",
    "VIEW_REGION",
    "CREATE_REGION",
    "VIEW_COUNTRY",
    "CREATE_COUNTRY",
  ],

  COMPANY_SUPER_USER: [
    "CREATE_BUSINESS_UNIT",
    "VIEW_BUSINESS_UNIT",
    "UPDATE_BUSINESS_UNIT",
    "DELETE_BUSINESS_UNIT",
    "VIEW_REGION",
    "CREATE_REGION",
    "UPDATE_REGION",
    "DELETE_REGION",
    "VIEW_COUNTRY",
    "CREATE_COUNTRY",
    "UPDATE_COUNTRY",
    "DELETE_COUNTRY",
  ],

  COMPANY_ADMIN: [
    // "CREATE_BUSINESS_UNIT",
    // "VIEW_BUSINESS_UNIT",
    // "VIEW_REGION",
    // "CREATE_REGION",
    // "VIEW_COUNTRY",
    // "CREATE_COUNTRY",

    "VIEW_SECTOR",
    "VIEW_INDUSTRY",
    "VIEW_SUB_INDUSTRY",
    "VIEW_JOB_FUNCTION",
    "VIEW_JOB_SUB_FUNCTION",
    "VIEW_COMPANY",
    "VIEW_BUSINESS_UNIT",
    "VIEW_REGION",
    "VIEW_COUNTRY",
    "VIEW_LEGAL_ENTITY",
    "VIEW_COMPANY_USER",
    "CREATE_BUSINESS_UNIT",
    "CREATE_REGION",
    "CREATE_COUNTRY",
    // "CREATE_COMPANY_USER",
    "CREATE_JOB_EVALUATION",
    "VIEW_JOB_EVALUATION",
    "CREATE_CUSTOM_JOB_FUNCTION",
    "VIEW_CUSTOM_JOB_FUNCTION",
    "UPDATE_CUSTOM_JOB_FUNCTION",
    "CREATE_CUSTOM_JOB_SUB_FUNCTION",
    "VIEW_CUSTOM_JOB_SUB_FUNCTION",
    "UPDATE_CUSTOM_JOB_SUB_FUNCTION",
    "VIEW_JE_DASHBOARD",
    "VIEW_JOB_LIBRARY",
  ],

  COMPANY_USER: [
    // "VIEW_BUSINESS_UNIT",
    // "VIEW_REGION",
    // "VIEW_COUNTRY"

    "VIEW_SECTOR",
    "VIEW_INDUSTRY",
    "VIEW_SUB_INDUSTRY",
    "VIEW_JOB_FUNCTION",
    "VIEW_JOB_SUB_FUNCTION",
    "VIEW_COMPANY",
    "VIEW_BUSINESS_UNIT",
    "VIEW_REGION",
    "VIEW_COUNTRY",
    "VIEW_LEGAL_ENTITY",
    "VIEW_COMPANY_USER",
    "CREATE_JOB_EVALUATION",
    "VIEW_JOB_EVALUATION",
    "CREATE_CUSTOM_JOB_FUNCTION",
    "VIEW_CUSTOM_JOB_FUNCTION",
    "CREATE_CUSTOM_JOB_SUB_FUNCTION",
    "VIEW_CUSTOM_JOB_SUB_FUNCTION",
    "VIEW_JE_DASHBOARD",
    "VIEW_JOB_LIBRARY",
  ],

  COMPANY_BUSINESS_ACCESS: [
    // "VIEW_BUSINESS_UNIT",
    // "VIEW_REGION",
    // "VIEW_COUNTRY",

    "VIEW_SECTOR",
    "VIEW_INDUSTRY",
    "VIEW_SUB_INDUSTRY",
    "VIEW_JOB_FUNCTION",
    "VIEW_JOB_SUB_FUNCTION",
    "VIEW_COMPANY",
    "VIEW_BUSINESS_UNIT",
    "VIEW_REGION",
    "VIEW_COUNTRY",
    "VIEW_LEGAL_ENTITY",
    "VIEW_COMPANY_USER",
    "VIEW_JOB_EVALUATION",
    "VIEW_CUSTOM_JOB_FUNCTION",
    "VIEW_CUSTOM_JOB_SUB_FUNCTION",
    "VIEW_JE_DASHBOARD",
    "VIEW_JOB_LIBRARY",
  ],
};

const JeTab = ({
  JeData,
  createDataCallback,
}: {
  JeData: any;
  createDataCallback: (key: string, data: any) => void;
}) => {
  const { user } = useTypedSelector(state => state.auth);
  const [businessUnitState, setBusinessUnitState] = useState<string[]>([]);
  const [regionState, setRegionState] = useState<string[]>([]);
  const [regions, setRegions] = useState<Partial<IRegion>[]>([]);
  const [countryState, setCountryState] = useState<string[]>([]);
  const [countries_id, setCountryIdState] = useState<string[]>([]);
  const [countries, setCountries] = useState<Partial<ICountry>[]>([]);
  const [grade, setGrade] = useState<string[]>([]);
  const [jobFunctionState, setJobFunctionState] = useState<string[]>([]);
  const [role, setRole] = useState<string>("");
  const [isCustomRole, setIsCustomRole] = useState<boolean>(false);
  const [firstTimeData, setFirstTimeData] = useState<boolean>(true);
  const [setData, setSetData] = useState<boolean>(false);
  const [permissionArray, setPermissionArray] = useState<string[]>([]);
  const [permissionAPIArray, setPermissionAPIArray] = useState<string[]>([]);
  const [accessGranted, setAccessGranted] = useState<boolean>(false);
  const [JEDashboard, setJEDashboard] = useState<boolean>(false);

  const [validationErrors, setValidationErrors] = useState({
    businessUnits: "",
    regions: "",
    countries: "",
    grades: "",
    jobFunctions: "",
    role: "",
  });

  const params: { company_id: string } = useParams();
  const countriesRef = useRef<any>(null);
  const gradesRef = useRef<any>(null);
  const jobFunctionsRef = useRef<any>(null);
  const paramsCompanyId = params.company_id;
  const { id: company_id } = user?.company || { id: paramsCompanyId };

  const { data: businessUnitsData, isLoading: isLoadingBusinessUnits } =
    useFetchAllBusinessUnitsQuery({ company_id });
  const { data: businessUnits } = businessUnitsData || {};

  const { data: gradesData, isLoading: isLoadingGrades } =
    useFetchJobGradesByCountryQuery(
      { company_id, countries_id },
      { refetchOnMountOrArgChange: true }
    );
  const { data: grades } = gradesData || {};

  // const { data: jobFunctionsData, isLoading: isLoadingJobFunctions } =
  //   useFetchAllJobFunctionsQuery(null);
  // const { data: jobFunctions } = jobFunctionsData || {};

  const { data: companyJobFunctionsData, isLoading: isLoadingJobFunctions } =
    useFetchAllCompanyFunctionsQuery({ company_id });

  const { data: jobFunctions } = companyJobFunctionsData || {};

  // ---------------- INIT LOAD ----------------
  useEffect(() => {
    if (
      JeData &&
      !isLoadingBusinessUnits &&
      !isLoadingGrades &&
      !isLoadingJobFunctions &&
      firstTimeData
    ) {
      const apiBusiness = (JeData?.metafield?.business_units || []).map(String);
      const apiRegions = (JeData?.metafield?.regions || []).map(String);
      const apiCountries = (JeData?.metafield?.countries || []).map(String);
      const apiGrades = (JeData?.metafield?.grades || []).map(String);
      const apiJobFunctions = (
        JeData?.metafield?.company_job_functions || []
      ).map(String);

      const extractRegionsFromBU = businessUnits?.filter((elm: any) =>
        apiBusiness.includes(String(elm.id))
      );
      let tempRegions: any[] = [];
      extractRegionsFromBU?.forEach((elm: any) => {
        if (Array.isArray(elm.regions)) tempRegions.push(...elm.regions);
      });
      const distinctRegions = Object.values(
        tempRegions.reduce((acc: any, r: any) => {
          if (!acc[r.id]) acc[r.id] = r;
          return acc;
        }, {})
      );
      setRegions(distinctRegions as Partial<IRegion>[]);

      let tempCountries: any[] = [];
      distinctRegions
        ?.filter((r: any) => apiRegions.includes(String(r.id)))
        ?.forEach((r: any) => {
          if (Array.isArray(r.countries)) tempCountries.push(...r.countries);
        });
      const distinctCountries = Object.values(
        tempCountries.reduce((acc: any, c: any) => {
          if (!acc[c.id]) acc[c.id] = c;
          return acc;
        }, {})
      );
      setCountries(distinctCountries as Partial<ICountry>[]);

      setBusinessUnitState(apiBusiness);
      setRegionState(apiRegions);
      setCountryState(apiCountries);
      setCountryIdState(apiCountries);
      setGrade(apiGrades);
      setJobFunctionState(apiJobFunctions);
      setPermissionAPIArray(JeData?.permissions || []);
      setPermissionArray(JeData?.permissions || []);
      setAccessGranted(JeData?.grant_access);
      setJEDashboard(
        JeData?.permissions?.includes("VIEW_JE_DASHBOARD") || false
      );

      setRole(JeData?.name || "");
      setIsCustomRole(
        ![
          "COMPANY_SUPER_USER",
          "COMPANY_ADMIN",
          "COMPANY_USER",
          "COMPANY_BUSINESS_ACCESS",
        ].includes(JeData?.name)
      );
      setFirstTimeData(false);
    }
  }, [
    JeData,
    isLoadingBusinessUnits,
    isLoadingGrades,
    isLoadingJobFunctions,
    firstTimeData,
  ]);

  // ---------------- RESYNC AFTER DATA READY ----------------
  useEffect(() => {
    if (!firstTimeData) {
      if (grades?.length && grade?.length) setGrade(prev => prev.map(String));
      if (jobFunctions?.length && jobFunctionState?.length)
        setJobFunctionState(prev => prev.map(String));
    }
  }, [grades, jobFunctions]);

  // ---------------- VALIDATION ----------------
  // const validateFields = (): boolean => {
  //   if (!accessGranted) {
  //     setValidationErrors({
  //       businessUnits: "",
  //       regions: "",
  //       countries: "",
  //       grades: "",
  //       jobFunctions: "",
  //       role: "",
  //     });
  //     return true;
  //   }

  //   const errors: any = {};
  //   if (!businessUnitState.length)
  //     errors.businessUnits = "Please select at least one Business Unit.";
  //   if (!regionState.length)
  //     errors.regions = "Please select at least one Region.";
  //   if (!countryState.length)
  //     errors.countries = "Please select at least one Country.";
  //   if (!grade.length) errors.grades = "Please select at least one Grade.";
  //   if (!jobFunctionState.length)
  //     errors.jobFunctions = "Please select at least one Job Function.";
  //   if (!role.trim()) errors.role = "Please define a Role.";

  //   setValidationErrors(errors);
  //   return Object.keys(errors).length === 0;
  // };

  // ---------------- VALIDATION ----------------
  const validateFields = (): boolean => {
    // If no access granted, skip all validations
    if (!accessGranted) {
      setValidationErrors({
        businessUnits: "",
        regions: "",
        countries: "",
        grades: "",
        jobFunctions: "",
        role: "",
      });
      return true;
    }

    // ✅ NEW: If role is COMPANY_SUPER_USER, skip dependent field validation
    if (role === "COMPANY_SUPER_USER") {
      const errors: any = {};
      if (!role.trim()) errors.role = "Please define a Role.";
      setValidationErrors(errors);
      return Object.keys(errors).length === 0;
    }

    // Normal validation for all other roles
    const errors: any = {};
    if (!businessUnitState.length)
      errors.businessUnits = "Please select at least one Business Unit.";
    if (!regionState.length)
      errors.regions = "Please select at least one Region.";
    if (!countryState.length)
      errors.countries = "Please select at least one Country.";
    if (!grade.length) errors.grades = "Please select at least one Grade.";
    if (!jobFunctionState.length)
      errors.jobFunctions = "Please select at least one Job Function.";
    if (!role.trim()) errors.role = "Please define a Role.";

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    createDataCallback("je_validation", validateFields);
  }, [
    accessGranted,
    JEDashboard,
    businessUnitState,
    regionState,
    countryState,
    grade,
    jobFunctionState,
    role,
  ]);

  // ---------------- DATA CREATE ----------------
  useEffect(() => {
    if (setData) {
      handleCreateData();
      setSetData(false);
    }
  }, [setData]);

  const handleCreateData = () => {
    const data = {
      grant_access: accessGranted,
      name: role,
      description: role,
      metafield: {
        business_units: businessUnitState,
        regions: regionState,
        countries: countryState,
        grades: grade,
        company_job_functions: jobFunctionState,
      },
      permissions: permissionArray,
    };
    createDataCallback("je", data);
  };

  // ---------------- HANDLERS ----------------
  const handleChange = (newValue: any) => {
    if (newValue?.length) {
      const selectedBU = newValue.map((v: any) => v.value);
      setBusinessUnitState(selectedBU);
      const selectedBUs = businessUnits.filter((bu: any) =>
        selectedBU.includes(bu.id)
      );
      const tempRegions: any[] = [];
      selectedBUs.forEach((bu: any) => {
        if (Array.isArray(bu.regions)) tempRegions.push(...bu.regions);
      });
      const distinctRegions = Object.values(
        tempRegions.reduce((acc: any, region: any) => {
          if (!acc[region.id]) acc[region.id] = region;
          return acc;
        }, {})
      ) as Partial<IRegion>[];

      setRegions(distinctRegions);

      setRegions(distinctRegions);
      setRegionState([]);
      setCountries([]);
      setCountryState([]);
    } else {
      setRegions([]);
      setRegionState([]);
      setCountries([]);
      setCountryState([]);
      setBusinessUnitState([]);
    }
    setSetData(true);
  };

  const handleRegionChange = (newValue: any) => {
    if (newValue?.length) {
      const selectedRegions = newValue.map((v: any) => v.value);
      setRegionState(selectedRegions);
      const tempCountries: any[] = [];
      regions
        .filter((r: any) => selectedRegions.includes(r.id))
        .forEach((r: any) => {
          if (Array.isArray(r.countries)) tempCountries.push(...r.countries);
        });
      const distinctCountries = Object.values(
        tempCountries.reduce((acc: any, c: any) => {
          if (!acc[c.id]) acc[c.id] = c;
          return acc;
        }, {})
      ) as Partial<ICountry>[];

      setCountries(distinctCountries);

      setCountries(distinctCountries);
      setCountryState([]);
    } else {
      setCountries([]);
      setCountryState([]);
      setRegionState([]);
    }
    setSetData(true);
  };

  const handleCountryChange = (newValue: any) => {
    if (newValue?.length) {
      const selectedCountries = newValue.map((v: any) => v.value);
      setCountryState(selectedCountries);
      setCountryIdState(selectedCountries);
    } else {
      setCountryState([]);
      setCountryIdState([]);
    }
    setSetData(true);
  };

  const changeGrantedAccess = () => {
    setAccessGranted(!accessGranted);
    setSetData(true);
  };

  const changeJEDashboard = () => {
    const newVal = !JEDashboard;
    setJEDashboard(newVal);
    if (newVal && !permissionArray.includes("VIEW_JE_DASHBOARD"))
      setPermissionArray([...permissionArray, "VIEW_JE_DASHBOARD"]);
    else
      setPermissionArray(
        permissionArray.filter(p => p !== "VIEW_JE_DASHBOARD")
      );
    setSetData(true);
  };

  const getPermissionsForRole = (role: string): string[] =>
    rolePermissions[role] || [];

  // --- COMPANY_SUPER_USER AUTO-HANDLING ---
  useEffect(() => {
    if (role === "COMPANY_SUPER_USER") {
      // Clear dependent fields only once on role change or load
      setBusinessUnitState([]);
      setRegionState([]);
      setRegions([]);
      setCountryState([]);
      setCountries([]);
      setGrade([]);
      setJobFunctionState([]);

      // Ensure toggles enabled
      if (!accessGranted) setAccessGranted(true);
      if (!JEDashboard) setJEDashboard(true);

      // Apply super user permissions
      const superPermissions = getPermissionsForRole("COMPANY_SUPER_USER");
      setPermissionArray(superPermissions);
      setPermissionAPIArray(superPermissions);

      // ❌ DO NOT call setSetData(true) here — it causes premature payloads
      // ✅ Instead, we’ll only trigger payload when user updates explicitly
    }
  }, [role]);

  // ---------------- JSX ----------------
  return (
    <>
      <div className="sub__admin_details_container">
        <div className="flex">
          <div style={{ padding: "32px 20px 12px" }}>
            <div
              style={{
                backgroundColor: "#FAFAFA",
                padding: "16px",
                borderRadius: "8px",
                width: "max-content",
              }}
            >
              <span style={{ fontWeight: 500, marginRight: "16px" }}>
                Grant Access
              </span>
              <Switch checked={accessGranted} onChange={changeGrantedAccess} />
            </div>
          </div>

          <div style={{ padding: "32px 20px 12px" }}>
            <div
              style={{
                backgroundColor: "#FAFAFA",
                padding: "16px",
                borderRadius: "8px",
                width: "max-content",
              }}
            >
              <span style={{ fontWeight: 500, marginRight: "16px" }}>
                TAREF Dashboard
              </span>
              <Switch checked={JEDashboard} onChange={changeJEDashboard} />
            </div>
          </div>
        </div>

        <div className="form__section">
          <div className="form__section_container  grid grid-cols-2 gap-10">
            {/* Business Units */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Choose Business Units</label>
              <Select
                isMulti
                isDisabled={!accessGranted || role === "COMPANY_SUPER_USER"}
                placeholder="Select Business Units"
                value={businessUnits
                  ?.filter((b: any) => businessUnitState.includes(String(b.id)))
                  ?.map((b: any) => ({
                    label: b.name,
                    value: String(b.id),
                  }))}
                options={[
                  { label: "All", value: "all" },
                  ...(businessUnits?.map((b: any) => ({
                    label: b.name,
                    value: String(b.id),
                  })) || []),
                ]}
                onChange={(newValue: any) => {
                  let selectedIds: string[] = [];

                  // Check if "All" is selected
                  if (newValue.some((v: any) => v.value === "all")) {
                    // If "All" is being selected, select all business units
                    selectedIds =
                      businessUnits?.map((b: any) => String(b.id)) || [];
                  } else {
                    // Otherwise, use the selected values
                    selectedIds = newValue.map((v: any) => String(v.value));
                  }

                  setBusinessUnitState(selectedIds);
                  // rebuild dependent data
                  const selectedBUs = businessUnits.filter((bu: any) =>
                    selectedIds.includes(String(bu.id))
                  );
                  const tempRegions: any[] = [];
                  selectedBUs.forEach((bu: any) => {
                    if (Array.isArray(bu.regions))
                      tempRegions.push(...bu.regions);
                  });
                  const distinctRegions = Object.values(
                    tempRegions.reduce((acc: any, r: any) => {
                      if (!acc[r.id]) acc[r.id] = r;
                      return acc;
                    }, {})
                  ) as Partial<IRegion>[];
                  setRegions(distinctRegions);
                  setRegionState([]);
                  setCountries([]);
                  setCountryState([]);
                  setSetData(true);

                  setValidationErrors(prev => ({
                    ...prev,
                    businessUnits: "",
                  }));
                }}
              />

              {validationErrors.businessUnits && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.businessUnits}
                </p>
              )}
            </div>

            {/* Regions */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Choose Regions</label>
              <Select
                isMulti
                isDisabled={
                  !accessGranted ||
                  !businessUnitState.length ||
                  role === "COMPANY_SUPER_USER"
                }
                placeholder="Select Regions"
                value={regions
                  ?.filter(r => regionState.includes(String(r.id)))
                  ?.map(r => ({ label: r.name, value: String(r.id) }))}
                options={[
                  { label: "All", value: "all" },
                  ...(regions?.map(r => ({
                    label: r.name,
                    value: String(r.id),
                  })) || []),
                ]}
                onChange={(newValue: any) => {
                  let selectedIds: string[] = [];

                  // Check if "All" is selected
                  if (newValue.some((v: any) => v.value === "all")) {
                    // If "All" is being selected, select all regions
                    selectedIds = regions?.map((r: any) => String(r.id)) || [];
                  } else {
                    // Otherwise, use the selected values
                    selectedIds = newValue.map((v: any) => String(v.value));
                  }

                  setRegionState(selectedIds);
                  const selectedRegions = regions.filter((r: any) =>
                    selectedIds.includes(String(r.id))
                  );
                  const tempCountries: any[] = [];
                  selectedRegions.forEach((r: any) => {
                    if (Array.isArray(r.countries))
                      tempCountries.push(...r.countries);
                  });
                  const distinctCountries = Object.values(
                    tempCountries.reduce((acc: any, c: any) => {
                      if (!acc[c.id]) acc[c.id] = c;
                      return acc;
                    }, {})
                  ) as Partial<ICountry>[];
                  setCountries(distinctCountries);
                  setCountryState([]);
                  setSetData(true);
                  setValidationErrors(prev => ({
                    ...prev,
                    regions: "",
                  }));
                }}
              />

              {validationErrors.regions && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.regions}
                </p>
              )}
            </div>

            {/* Countries */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Choose Countries</label>

              <Select
                ref={countriesRef}
                isMulti
                closeMenuOnSelect={false} // keeps dropdown open for multiple selections
                isDisabled={
                  !accessGranted ||
                  !regionState.length ||
                  role === "COMPANY_SUPER_USER"
                }
                placeholder="Select Countries"
                value={countries
                  ?.filter(c => countryState.includes(String(c.id)))
                  ?.map(c => ({ label: c.name, value: String(c.id) }))}
                options={[
                  { label: "All", value: "all" }, // Inline "All" option
                  ...(countries?.map(c => ({
                    label: c.name,
                    value: String(c.id),
                  })) || []),
                ]}
                onChange={val => {
                  const isAllSelected = val.some((v: any) => v.value === "all");

                  if (isAllSelected) {
                    const allIds = countries?.map(c => String(c.id)) || [];
                    const alreadyAllSelected =
                      countryState.length === allIds.length;

                    const selected = alreadyAllSelected ? [] : allIds;
                    setCountryState(selected);
                    setCountryIdState(selected);
                    countriesRef.current?.blur();
                  } else {
                    const selected = val.map((v: any) => String(v.value));
                    setCountryState(selected);
                    setCountryIdState(selected);
                  }

                  // Clear validation and dependent fields if needed
                  setValidationErrors(prev => ({
                    ...prev,
                    countries: "",
                  }));

                  setSetData(true);
                }}
              />

              {validationErrors.countries && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.countries}
                </p>
              )}
            </div>

            {/* Grades */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Choose Grades</label>

              <Select
                isMulti
                ref={gradesRef}
                closeMenuOnSelect={false} // keeps dropdown open for multiple selections
                isDisabled={
                  !accessGranted ||
                  !countryState.length ||
                  role === "COMPANY_SUPER_USER"
                }
                placeholder="Select Grades"
                value={grades
                  ?.filter((g: any) => grade.includes(String(g.id)))
                  ?.map((g: any) => ({ label: g.grade, value: String(g.id) }))}
                options={[
                  { label: "All", value: "all" }, // Inline "All" option
                  ...(grades?.map((g: any) => ({
                    label: g.grade,
                    value: String(g.id),
                  })) || []),
                ]}
                onChange={val => {
                  const isAllSelected = val.some((v: any) => v.value === "all");

                  if (isAllSelected) {
                    const allIds = grades?.map((g: any) => String(g.id)) || [];
                    const alreadyAllSelected = grade.length === allIds.length;

                    const selectedGrades = alreadyAllSelected ? [] : allIds;
                    setGrade(selectedGrades);
                    gradesRef.current?.blur();
                  } else {
                    const selectedGrades = val.map((v: any) => String(v.value));
                    setGrade(selectedGrades);
                  }

                  setSetData(true);

                  // Clear validation
                  setValidationErrors(prev => ({
                    ...prev,
                    grades: "",
                  }));
                }}
              />

              {validationErrors.grades && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.grades}
                </p>
              )}
            </div>

            {/* Job Functions */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">
                Choose Company Job Functions
              </label>

              <Select
                isMulti
                closeMenuOnSelect={false} // keeps dropdown open for multiple selections
                isDisabled={
                  !accessGranted ||
                  !businessUnitState.length ||
                  role === "COMPANY_SUPER_USER"
                }
                ref={jobFunctionsRef}
                placeholder="Select Job Functions"
                value={jobFunctions
                  ?.filter((j: any) => jobFunctionState.includes(String(j.id)))
                  ?.map((j: any) => ({ label: j.name, value: String(j.id) }))}
                options={[
                  { label: "All", value: "all" }, // Inline "All" option
                  ...(jobFunctions?.map((j: any) => ({
                    label: j.name,
                    value: String(j.id),
                  })) || []),
                ]}
                onChange={val => {
                  const isAllSelected = val.some((v: any) => v.value === "all");

                  if (isAllSelected) {
                    const allIds =
                      jobFunctions?.map((j: any) => String(j.id)) || [];
                    const alreadyAllSelected =
                      jobFunctionState.length === allIds.length;

                    const selectedJobFunctions = alreadyAllSelected
                      ? []
                      : allIds;
                    setJobFunctionState(selectedJobFunctions);
                    jobFunctionsRef.current?.blur();
                  } else {
                    const selectedJobFunctions = val.map((v: any) =>
                      String(v.value)
                    );
                    setJobFunctionState(selectedJobFunctions);
                  }

                  setSetData(true);

                  // Clear validation
                  setValidationErrors(prev => ({
                    ...prev,
                    jobFunctions: "",
                  }));
                }}
              />

              {validationErrors.jobFunctions && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.jobFunctions}
                </p>
              )}
            </div>

            {/* Role */}
            <div style={{ marginBottom: "20px" }}>
              <label className="input__label">Role</label>

              {!isCustomRole ? (
                <Select
                  isDisabled={!accessGranted}
                  placeholder="Select from default roles"
                  value={
                    [
                      {
                        label: "COMPANY_SUPER_USER",
                        value: "COMPANY_SUPER_USER",
                      },
                      { label: "COMPANY_ADMIN", value: "COMPANY_ADMIN" },
                      { label: "COMPANY_USER", value: "COMPANY_USER" },
                      {
                        label: "COMPANY_BUSINESS_ACCESS",
                        value: "COMPANY_BUSINESS_ACCESS",
                      },
                    ].find(r => r.value === role) || null
                  }
                  options={[
                    {
                      label: "COMPANY_SUPER_USER",
                      value: "COMPANY_SUPER_USER",
                    },
                    { label: "COMPANY_ADMIN", value: "COMPANY_ADMIN" },
                    { label: "COMPANY_USER", value: "COMPANY_USER" },
                    {
                      label: "COMPANY_BUSINESS_ACCESS",
                      value: "COMPANY_BUSINESS_ACCESS",
                    },
                  ]}
                  onChange={(newValue: any) => {
                    setRole(newValue?.value);
                    const permissions = getPermissionsForRole(newValue?.value);
                    setPermissionAPIArray(permissions);
                    setPermissionArray(permissions);
                    setValidationErrors(prev => ({
                      ...prev,
                      role: "",
                    }));
                    setSetData(true);
                  }}
                />
              ) : (
                <input
                  style={{
                    border: "0.75px solid #d9d9d9",
                    padding: "0.5rem 11px",
                    borderRadius: "2px",
                  }}
                  type="text"
                  disabled={!accessGranted}
                  placeholder="Enter custom role"
                  value={role}
                  onChange={e => {
                    setRole(e.target.value);
                    setValidationErrors(prev => ({
                      ...prev,
                      role: "",
                    }));
                    setSetData(true);
                  }}
                />
              )}

              {validationErrors.role && (
                <p className="text-red-500 text-xs mt-1">
                  {validationErrors.role}
                </p>
              )}

              {!isCustomRole ? (
                <div
                  className="change_role"
                  onClick={() => {
                    setIsCustomRole(true);
                    setRole("");
                  }}
                >
                  Create custom role
                </div>
              ) : (
                <div
                  className="change_role"
                  onClick={() => {
                    setIsCustomRole(false);
                    setRole("");
                  }}
                >
                  Select from default roles
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Permissions Table */}
      <div className="sub__admin_details_container">
        <h1 className="section__heading margin__bottom__0">
          Permission Settings
        </h1>
        <div className="form__section">
          <div className="form__section_container">
            <PermissionsTable
              hideJe={false}
              role={role === "COMPANY_SUPER_USER"}
              setCallback={(val: any) => {
                setPermissionArray(val);
                setSetData(true);
              }}
              permissionAPIArray={permissionArray}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default JeTab;
